<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h1>
          {{ title }}
          <span class="badge rounded mx-2" :class="getStatusClass(statusCode)">{{ statusDisplayName }}</span>
        </h1>
      </div>
    </div>
    <div v-if="hasInvestigationId" class="row">
      <div class="col">
        <h6>Investigation Id: {{ this.report.registration.investigationId }}</h6>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <Registration :report="report" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <Summary :organizationId="organizationId" :reportId="reportId" :report="report" />
      </div>
    </div>
    <div class="row mt-4" v-if="!hasData">
      <div class="col">
        <div class="alert alert-danger font-weight-bolder" style="font-size: 1.1rem" role="alert">
          {{ noDataText }}
        </div>
      </div>
    </div>
    <div class="row my-4" v-if="hasData">
      <div class="col">
        <Consistency :organizationId="organizationId" :reportId="reportId" :report="report" />
      </div>
    </div>
    <div class="row my-4" v-if="hasData">
      <div class="col">
        <h4 class="text-capitalize">Comments</h4>
        <div class="card my-2" v-for="comment in comments" :key="comment.commentId">
          <div class="card-body py-1">
            <p class="font-italic">{{ comment.text }}</p>
            <p class="mb-0 text-muted">{{ comment.userFullName }} on {{ formatter.date.long(comment.timestamp) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Registration from "@/views/reports/report/edit-report/Registration.vue";
import Summary from "@/views/reports/report/edit-report/Summary.vue";
import Consistency from "@/views/reports/report/edit-report/Consistency.vue";
import formatter from "@/utils/formatter";

export default {
  components: {
    Registration,
    Summary,
    Consistency,
  },
  props: {
    organizationId: String,
    reportId: String,
  },
  data() {
    return {
      report: null,
    };
  },
  computed: {
    formatter: () => formatter,
    hasData() {
      if (this.report && this.report.summary && (this.report.summary.scoreCode === "inconclusive" || this.report.statusCauseCode === "timeout")) return false;
      if (this.statusCode === "completed") return true;
      return false;
    },
    registration() {
      return this.report ? this.report.registration || {} : {};
    },
    hasInvestigationId() {
      return this.report && this.report.registration && this.report.registration.investigationId;
    },
    summary() {
      return this.report ? this.report.summary || {} : {};
    },
    categories() {
      return this.report ? this.report.categories || [] : [];
    },
    title() {
      if (!this.report) return null;
      if (this.report.title) return this.report.title;
      if (this.report.registration && this.report.registration.registrationId) return `${this.report.registration.registrationId}`;
      if (this.report.referenceNumber) return `Report #${this.report.referenceNumber}`;
      return null;
    },
    statusCode() {
      if (this.report && this.report.statusCode) return this.report.statusCode;
      return "unknown";
    },
    statusDisplayName() {
      if (this.report && this.report.statusDisplayName) return this.report.statusDisplayName;
      return "Unknown";
    },
    noDataText() {
      if (this.report && this.report.statusCauseCode === "timeout")
        return "The test taker allowed too many questions to time out to generate an accurate report.  This situation places the candidate Below Conditions.";
      if (this.statusCode === "unknown") return "The status of this test is currently unknown.";
      if (this.statusCode === "created") return "This test has not yet been administered. A report has not been generated.";
      if (this.statusCode === "sent-by-email") return "This test has been sent by email, but not yet started. A report has not been generated.";
      if (this.statusCode === "in-progress") return "This test is currently in progress. A report has not been generated.";
      if (this.statusCode === "declined") return "The test taker declined the consent form.";
      if (this.report && this.report.summary && this.report.summary.scoreCode === "inconclusive")
        return "The test taker did not answer enough questions to generate a report.";
      return "";
    },
    comments() {
      if (!this.report || !this.report.comments) return [];
      return this.report.comments.filter(c => c.subjectType === "report" && c.subjectId == this.report.reportId);
    },
  },
  created() {
    this.$axios
      .get(`/v1/organizations/${this.organizationId}/reports/${this.reportId}`)
      .then(res => (this.report = res.data))
      .catch(err => (this.error = err))
      .finally(() => this.print());
  },
  methods: {
    print() {
      setTimeout(() => (window.printReady = true), 500);
    },
    getStatusClass(value) {
      if (value == "created") return "badge-info";
      if (value == "sent-by-email") return "badge-info";
      if (value == "in-progress") return "badge-warning";
      if (value == "declined") return "badge-danger";
      if (value == "completed") return "badge-success";
      return "badge-secondary";
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  font-size: 40%;
  vertical-align: super;
}
</style>
